import {StyleSheet} from "aphrodite";

import {useOnMountEffect, View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {useMarkConversion} from "@khan/analytics-learning-time";
import {PageLifecycle} from "@khan/analytics-performance";
import {LogIn} from "@khan/auth-login";
import {NeedAnAccount} from "@khan/auth-signup";
import {mediaQueries} from "@khan/shared-styles";

import PageRoot from "#app-shell-package/page-root.tsx";

/**
 * A page to allow the user to log in via any method of their choice.
 * This includes email/password, Google, Facebook, Apple, and Clever
 */
const LogInPage = ({continueUrl}: {continueUrl?: string}) => {
    const markConversion = useMarkConversion();
    useOnMountEffect(() => {
        PageLifecycle.reportPageLifecycleTiming("login_page", {
            interactive: true,
            usable: true,
        });

        markConversion({id: "pageview_login"});
    });
    return (
        <PageRoot settings={{footer: false, noIndex: true, noFollow: true}}>
            <View style={styles.page}>
                <LogIn
                    signupComponent={<NeedAnAccount />}
                    continueUrl={continueUrl}
                />
            </View>
        </PageRoot>
    );
};

const styles = StyleSheet.create({
    page: {
        marginTop: spacing.large_24,
        [mediaQueries.lgOrLarger]: {
            marginTop: spacing.xxLarge_48,
        },
    },
});

export default LogInPage;
